import React from "react";
import { motion } from "framer-motion";

const PURPLE_GRADIENT = "linear-gradient(0.68deg, #A28FDC 0.74%, #7C3AED 74.61%)";

const DailyRentalCardMob = ({ car, onBook, freeKm }) => {
  const price = car.rentPerHr != null ? Number(car.rentPerHr) : null;

  return (
    <motion.article
      layout
      className={`relative bg-white border-[0.6px] border-[#E5E7EB] rounded-[9px] drop-shadow-[0px_6px_9.7px_rgba(212,184,184,0.07)] flex items-center justify-between gap-2 p-3 overflow-hidden min-w-0 ${car.isSoldOut ? "opacity-60" : ""}`}
    >
      {/* Left: details */}
      <div className="flex flex-col gap-2 h-[145px] items-start shrink-0">
        {/* Name + body type */}
        <div className="flex flex-col gap-[5.5px] items-start w-full">
          <span className="text-[#252525] text-[16px] font-semibold font-['Outfit'] leading-[1.2] tracking-[0.3px] text-left">
            {car.name}
          </span>
          {car.bodyTypeText && (
            <span className="px-[6px] py-[1.5px] bg-[#F9FAFB] border-[0.8px] border-[#F3F3F9] rounded-[3.2px] text-[#1D4ED8] text-[10px] font-semibold font-['Outfit'] uppercase tracking-[0.75px] whitespace-nowrap">
              {car.bodyTypeText}
            </span>
          )}
        </div>

        {/* Specs pills */}
        <div className="flex items-center gap-[5.5px]">
          {[`${car.seater} Seats`, car.transmissionTypeText, car.fuelTypeText].map((spec, i) => (
            <span
              key={i}
              className="p-[5.5px] bg-[#F9FAFB] border-[0.7px] border-[#E5E7EB] rounded-[5.5px] text-[#111827] text-[10px] font-semibold font-['Outfit'] whitespace-nowrap"
            >
              {spec}
            </span>
          ))}
        </div>

        {/* Pricing + free km */}
        <div className="flex flex-col h-[63px] items-start justify-between w-full">
          <div className="flex flex-col gap-[9px] items-start">
            {price != null ? (
              <div className="flex items-end text-[#CD2525] whitespace-nowrap leading-none">
                <span className="text-[20px] font-bold font-['Outfit'] tracking-[-0.2px]">
                  ₹{price.toLocaleString("en-IN")}
                </span>
                <span className="text-[14px] font-medium font-['Outfit'] tracking-[0.42px]">/hr</span>
              </div>
            ) : (
              <span className="text-[#9CA3AF] text-[14px] font-medium font-['Outfit'] leading-none">Price unavailable</span>
            )}
            <p className="text-black text-[10px] font-bold font-['Outfit'] leading-[15px] tracking-[0.45px] text-left">
              {car.baseFare != null && car.taxAmount != null && (
                <span>₹ {(Number(car.baseFare) + Number(car.taxAmount)).toLocaleString("en-IN")}/- </span>
              )}
              Incl. Taxes &amp; Excl. Fees
            </p>
          </div>
          {car.extraKmRental != null && freeKm > 0 && (
            <p className="text-[#727272] text-[10px] font-medium font-['Outfit'] tracking-[0.1px] text-left">
              ₹{Number(car.extraKmRental).toLocaleString("en-IN")}/km after{" "}
              <span className="text-[#1D4ED8] font-bold">{freeKm} km</span> limit
            </p>
          )}
        </div>
      </div>

      {/* Right: image + Book Now */}
      <div className="flex flex-col items-end justify-between h-[146px] flex-1 min-w-0 max-w-[184px]">
        <div className="w-full h-[103px] mt-[4.5px]">
          <img
            src={car.imageUrl || "/assets/sample.png"}
            alt={car.name}
            className="w-full h-full object-contain"
            loading="lazy"
          />
        </div>
        <button
          disabled={car.isSoldOut}
          onClick={() => onBook(car)}
          className={`h-[28.4px] w-[95px] mr-2 rounded-[6px] text-[12px] font-medium font-['Outfit'] tracking-[0.32px] text-white border-[0.6px] whitespace-nowrap ${car.isSoldOut ? "bg-gray-200 text-gray-400 border-gray-200" : "border-[#6595FF] drop-shadow-[0px_8px_9.7px_rgba(26,86,219,0.2)]"}`}
          style={!car.isSoldOut ? { backgroundImage: PURPLE_GRADIENT } : undefined}
        >
          {car.isSoldOut ? "Sold Out" : "Book Now"}
        </button>
      </div>
    </motion.article>
  );
};

export default DailyRentalCardMob;
